import { render, staticRenderFns } from "./PublishReports.vue?vue&type=template&id=6faa028b&"
import script from "./PublishReports.vue?vue&type=script&lang=js&"
export * from "./PublishReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports